import { useThemeStore } from "@/store/modules/theme";


// type BtnTypeArray = 'header-close' | 'foot-back' | 'foot-confirm';
export function useShowLayoutFootAndClose(config: Api.Common.footConfig) {
  const themeStore = useThemeStore();
  themeStore.updateFootShow(config);


}

export function useHideLayoutFootAndClose() {
  const themeStore = useThemeStore();
  themeStore.updateFootShow({ showKey: [] });

}


